import { render, staticRenderFns } from "./LocaleDetails.vue?vue&type=template&id=08600f77&"
import script from "./LocaleDetails.vue?vue&type=script&lang=js&"
export * from "./LocaleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports